/* source omitted */
